import BaseMapper from '../../BaseMapper';

const SpecifierMapper = (data, context) => {
    return data;
};

export default SpecifierMapper;
